export { default } from './Paginator';
